import React from 'react';

import {
  Center, Spinner, VStack, Text,
} from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';

import { Task } from '@/student/types';
import TaskDescription from './components/Instructions/TaskDescription';
import TaskObjectives, { hasApplicableObjectives } from './components/Instructions/TaskObjectives';

interface InstructionsPanelProps {
  task: Task | null;
  loading?: boolean;
  testID?: string;
}

const InstructionsPanel: React.FC<InstructionsPanelProps> = ({ task, loading, testID }) => {
  const { t } = useTranslation();

  if (loading) {
    return (
      <Center testID={`${testID}-loading`}>
        <Spinner />
      </Center>
    );
  }

  return (
    <VStack space="4xl" testID={testID}>
      <TaskDescription description={task?.description || ''} />
      {hasApplicableObjectives(task?.analysis?.dimensions) && (
        <VStack space="md">
          <Text size="xs" color="$textHint" fontWeight="bold" textTransform="uppercase" letterSpacing="$md">
            {t('student.task.instructions.objectives-tab', 'Objectives')}
          </Text>
          <TaskObjectives objectives={task?.analysis?.dimensions} />
        </VStack>
      )}
    </VStack>
  );
};

export default InstructionsPanel;
